var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaseLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6266 16H17.5047C19.0629 16 19.9533 15.1096 19.9533 13.4001V4.23817C19.9533 2.52866 19.0629 1.63829 17.3267 1.63829H8.71675C8.04007 1.63829 7.68392 1.51363 7.22092 1.10406L6.70451 0.658876C6.12576 0.14246 5.71619 0 4.82582 0H2.28826C0.810239 0 0 0.810239 0 2.43962V13.4001C0 15.1274 0.890373 16 2.6266 16ZM1.10406 2.50195C1.10406 1.55815 1.58486 1.08625 2.50195 1.08625H4.55871C5.20868 1.08625 5.55593 1.21981 6.03673 1.64719L6.54424 2.09238C7.10517 2.58208 7.55036 2.74235 8.44964 2.74235H17.2999C18.2883 2.74235 18.8492 3.27657 18.8492 4.3005V4.98609H1.10406V2.50195ZM2.64441 14.9048C1.64719 14.9048 1.10406 14.3706 1.10406 13.3467V6.02782H18.8492V13.3467C18.8492 14.3706 18.2883 14.9048 17.2999 14.9048H2.64441Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseLibrary);
export default __webpack_public_path__ + "static/media/caseLibrary.b7ebbbf954c3b5b0366bdcdcbfe1278e.svg";
export { ForwardRef as ReactComponent };